import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { 
  Box,
  Container,
  CssBaseline, 
  Snackbar,
  Alert,
  useTheme
} from '@mui/material';
import Header from '../common/Header';
import Footer from '../common/Footer';
import { RootState } from '../../store';
import { hideNotification } from '../../store/slices/uiSlice';

const MainLayout: React.FC = () => {
  const theme = useTheme();
  const { notification } = useSelector((state: RootState) => state.ui);
  const dispatch = useDispatch();
  const location = useLocation();
  const { currentScenario } = useSelector((state: RootState) => state.scenario);

  const handleNotificationClose = () => {
    dispatch(hideNotification());
  };
  
  // パスに基づいてツールバータイトルを設定
  const getToolTitle = () => {
    const path = location.pathname;
    
    if (path.startsWith('/scenarios')) {
      return 'TOP';
    } else if (path.startsWith('/roleplay-settings')) {
      return 'オリエンテーション';
    } else if (path.startsWith('/roleplay') && currentScenario) {
      return currentScenario.title;
    } else if (path.startsWith('/evaluation')) {
      return 'AIフィードバック';
    } else if (path.startsWith('/profile/change-password')) {
      return 'パスワード変更';
    } else if (path.startsWith('/help')) {
      return 'ヘルプ・お問い合わせ';
    }
    
    return '';
  };

  const toolTitle = getToolTitle();

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      bgcolor: theme.palette.background.paper,
      justifyContent: 'space-between',
    }}>
      <CssBaseline />
      <Header toolTitle={toolTitle} />
      <Container>
      <Box
        component="main"
        sx={{ 
          flexGrow: 1, 
          p: 3, 
          width: '100%',
          mt: '120px', // 2つのツールバーの高さ分のマージンを追加
        }}
      >
        <Outlet />
      </Box>
      </Container>
      <Snackbar 
        open={notification.show} 
        autoHideDuration={6000} 
        onClose={handleNotificationClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleNotificationClose} 
          severity={notification.type} 
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
      <Footer />
    </Box>
  );
};

export default MainLayout;
